import { type FC } from 'react';
import { Archive } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { FEATURES } from '@/config/features';
import type { Tramite } from '@/types';

interface ArchivadoBadgeProps {
  tramite: Pick<Tramite, 'archivado' | 'archivado_motivo'>;
  className?: string;
}

export const ArchivadoBadge: FC<ArchivadoBadgeProps> = ({ tramite, className }) => {
  // Con la feature apagada no se muestra: no habría forma de desarchivar.
  if (!FEATURES.archivadoEscrituras || !tramite.archivado) {
    return null;
  }

  return (
    // `secondary` y no `destructive`: archivar no es un estado de error, es
    // guardar una escritura terminada fuera del listado del día a día.
    <Badge
      variant="secondary"
      className={className}
      title={tramite.archivado_motivo || undefined}
    >
      <Archive className="h-3 w-3" />
      Archivada
    </Badge>
  );
};

export default ArchivadoBadge;
